import { Link } from "react-router-dom";
import type { WeekDoc } from "@/lib/types";
import { StatusBadge } from "./StatusBadge";

type Props = {
  week: WeekDoc;
  registered: number;
  total: number;
};

export function WeekCard({ week, registered, total }: Props) {
  const pct = total === 0 ? 0 : Math.min(100, Math.round((registered / total) * 100));
  const isClosed = week.status === "paid";
  const cta = isClosed ? "Xem Payroll" : "Xem & Duyệt";
  const ctaClass = isClosed
    ? "bg-blue-50 hover:bg-blue-500 text-blue-600 hover:text-white border-blue-200 hover:border-blue-500"
    : "bg-pink-50 hover:bg-pink-500 text-pink-600 hover:text-white border-pink-200 hover:border-pink-500";

  return (
    <Link
      to={`/manager/week/${week.startDate}`}
      className="group block rounded-3xl bg-white p-6 shadow-lg ring-1 ring-pink-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-pink-200/50"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-display text-xl font-black text-gray-900">Tuần {week.label}</div>
          <div className="mt-1 text-sm text-gray-500">
            {registered}/{total} nhân viên đã đăng ký
          </div>
        </div>
        <StatusBadge status={week.status} />
      </div>

      <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-pink-50">
        <div
          className="h-full rounded-full bg-gradient-to-r from-pink-400 to-rose-400 transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>

      <div
        className={`mt-4 flex h-10 w-full items-center justify-center rounded-full border text-sm font-semibold transition-all duration-300 ${ctaClass}`}
      >
        {cta}
      </div>
    </Link>
  );
}
